
let componentName: string = '';

export function getComponentName(): string {
  return componentName;
}

export function setComponentName(name: string) {
  componentName = name;
}